import { Link } from 'react-router-dom'
import servicesDetailsImg1 from '../../assets/images/services-details-img-1.jpg'
import servicesDetailsImg2 from '../../assets/images/services-details-img-2.jpg'
import servicesDetailsImg3 from '../../assets/images/services-details-img-3.jpg'

function ServiceDetail() {
    return (
        <>
            {/* <div className="page-banner-area pt-100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="single-page-banner-content">
                                <h1>Services Details</h1>
                                <ul>
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>
                                        Services Details
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="single-page-banner-img" >
                                <img src={pageBannerImg} alt="images" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="services-details-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="single-services-details-content">
                                <div className="details-img">
                                    <img src={servicesDetailsImg1} alt="images" />
                                </div>
                                <h2>Office Cleaning Service</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                    dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat pretium in hac habitasse
                                    platea dictumst aenean feugiat velit a venenatis metus in hac habitasse vehicula pharetra.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus.</p>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <div className="single-included-services">
                                            <h3>Included Services</h3>
                                            <ul>
                                                <li>100% Guarantee Cleaning</li>
                                                <li>24/7 Alltime Supporting</li>
                                                <li>Fully Carefull & Safety Guard</li>
                                                <li>Expert Team Members</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <div className="single-included-services">
                                            <h3>Benifits of services</h3>
                                            <ul>
                                                <li>No Hidden Charges</li>
                                                <li>Special Careness Risk Free</li>
                                                <li>Quality Standards</li>
                                                <li>15+ Years Experiences</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                    dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat.</p>
                                <h4>We Give The Best Services</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                    dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat pretium in hac habitasse
                                    platea dictumst aenean feugiat velit a vehicula pharetra.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus.</p>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <div className="services-details-img-two">
                                            <img src={servicesDetailsImg2} alt="images" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <div className="services-details-img-two">
                                            <img src={servicesDetailsImg3} alt="images" />
                                        </div>
                                    </div>
                                </div>
                                <h4>Brief Description Of Sevices</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit morbi mattis urna bibendum ornare malesuada fusce semper auctor nibh vitae feugiat nunc ut orci congue lobortis mauris eget venenatis metus in hac habitasse plat
                                    dictumst donec eleifend feugiat nisi quis pulvinar nam nec metus vel lorem feugiat.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="single-services-detalis-right">
                                <div className="services-details-search">
                                    <div className='d-flex justify-content-between'>
                                        <h2>Price</h2>
                                        <p><strong>$100.00</strong></p>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <Link className="default-btn mx-0" to="/cart">Add to Cart</Link>
                                    </div>
                                </div>
                                <div className="services-house-cleaning-card">
                                    <h2>Our Services</h2>
                                    <ul>
                                        <li><a href="#">House Cleaning <i className='bx bx-arrow-back'></i></a></li>
                                        <li><a href="#">Office Cleaning <i className='bx bx-arrow-back'></i></a></li>
                                        <li><a href="#">Windows Cleaning <i className='bx bx-arrow-back'></i></a></li>
                                        <li><a href="#">Bathtub Cleaning <i className='bx bx-arrow-back'></i></a></li>
                                        <li><a href="#">Outdoor Cleaning <i className='bx bx-arrow-back'></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceDetail